import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { refreshTokenLogin } from './redux/actions/auth';
import './App.scss';
import Auth from './Auth';

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

// Containers
const DefaultLayout = Loadable({
  loader: () => import('./containers/DefaultLayout'),
  loading,
});

// Pages
const Login = Loadable({
  loader: () => import('./views/Pages/Login/containers/Login'),
  loading,
});

const Page404 = Loadable({
  loader: () => import('./views/Pages/Page404'),
  loading,
});

const Page500 = Loadable({
  loader: () => import('./views/Pages/Page500'),
  loading,
});

class App extends Component {
  /**
   * コンポーネントマウント時の処理
   */
  componentWillMount() {
    const refreshToken = localStorage.getItem('refresh_token');
    const param = {
      refresh_token: refreshToken,
    };
    this.props.refreshTokenLogin(param);
  }

  render() {
    return (
      this.props.loading
        ? loading
        : (
          <HashRouter>
            <Switch>
              <Route exact path="/login" name="Login Page" component={Login} />
              <Route exact path="/404" name="Page 404" component={Page404} />
              <Route exact path="/500" name="Page 500" component={Page500} />
              <Auth>
                <Switch>
                  <Route path="/" name="Home" component={DefaultLayout} />
                </Switch>
              </Auth>
            </Switch>
          </HashRouter>
        )
    );
  }
}

const mapStateToProps = state => ({
  loading: state.auth.authLoading,
});

const mapDispatchToProps = dispatch => ({
  refreshTokenLogin: bindActionCreators(refreshTokenLogin, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
